import vxCartProductTile from '../vx-cart-product-tile/vx-cart-product-tile.vue';
// import shoppingCartData from '../vx-shopping-cart/vx-shopping-cart-mock-data';
import globals from '../../common/globals';
import vxEmptyCart from '../vx-empty-cart/vx-empty-cart.vue';
import vxSpinner from '../../common/vx-spinner/vx-spinner.vue';
import ManageShoppingCartService from '../../common/services/manage-shopping-cart-service';
import {
  cartEventBus,
  eventBus,
  globalEventBus,
} from '../../../modules/event-bus';


export default {
  name: 'vx-mini-cart',
  components: {
    vxCartProductTile,
    vxEmptyCart,
    vxSpinner,
  },
  props: {
    // Text coming from property file
    i18n: Object,
    // Indicates if cart is Sample (gpxpress)
    isSampleCart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shoppingCartData: {},
      globals,
      displayCount: 3,
      manageShoppingCartService: new ManageShoppingCartService(),
      dataLoaded: false,
    };
  },
  created() {
    // listening to emits of delete and edit item from cart-product tile component
    cartEventBus.$on('cart-update', () => {
      this.callShoppingCart();
    });
    cartEventBus.$on('cart-update-error', () => {
      // this.callShoppingCart('FULL');
    });
  },
  computed: {},
  mounted() {
    this.callMiniCart();
  },
  methods: {
    /**
     * This function gets mini cart details
     */
    callMiniCart() {
      this.dataLoaded = false;
      this.manageShoppingCartService.getDefaultCart({}, this.handleMiniCartResponse, this.handleMiniCartError);
      this.$refs.spinner.showSpinner();
    },
    /**
     * This function handles the response of mini cart details call
     */
    handleMiniCartResponse(response) {
      if (this.$refs.spinner) {
        this.$refs.spinner.hideSpinner();
      }
      if (response && response.data) {
        this.shoppingCartData = response.data;
        this.dataLoaded = true;
      }
    },
    /**
     * This function gets cart details
     */
    callShoppingCart() {
      const requestConfig = {};
      this.manageShoppingCartService.getFullCartService(requestConfig, this.handleShoppingCartResponse, this.handleShoppingCartError);
      // this.spinnerComponent.showSpinner();
    },
        /**
     * This function handles the response of cart details
     */
    handleShoppingCartResponse(response) {
     // this.spinnerComponent.hideSpinner();
      if (response && response.data) {
        this.shoppingCartData = response.data;
        this.individualProducts = this.shoppingCartData.entries.filter(product => !product.hasOwnProperty('rootBundleTemplate'));
        this.generateBundleData();
        if (this.shoppingCartData.appliedOrderPromotions.length) {
          this.shoppingCartData.appliedOrderPromotions.map((promotion) => {
            if (promotion.giveAwayCouponCodes.length && promotion.description) {
              this.giveAwayCouponDescription = promotion.description;
            } else {
              this.giveAwayCouponDescription = '';
            }
          });
        } else {
          this.giveAwayCouponDescription = '';
        }
        eventBus.$emit('cart-details', this.shoppingCartData.entries);
        cartEventBus.$emit('total-items-updated', response.data.totalItems, response.data.code);
        if (this.globals.isB2B()) {
          if (this.globals.getIsLoggedIn()) {
            this.showLeaseError();
          }
          this.installationPrice = this.getInstallationPrice();
        }
        this.promotionData = this.getProductPromotions();
        if (this.shoppingCartData.entries.length !== 0) {
          this.cartHasVisibleItems = true;
        } else {
          this.cartHasVisibleItems = false;
        }
        this.$root.$emit('cartHasVisibleItems', this.cartHasVisibleItems);
        this.$root.$emit('full-cart-called', this.shoppingCartData);
        this.$root.$emit('cart-reloaded', true);
      }
    },
    /**
     * This function handles the error of cart details
     */
    handleShoppingCartError() {
      this.spinnerComponent.hideSpinner();
      this.cartHasVisibleItems = false;
      this.$root.$emit('cartHasVisibleItems', this.cartHasVisibleItems);
    },
    /**
     * This function handles the error of mini cart details call
     */
    handleMiniCartError(error) {
      if (this.$refs.spinner) {
        this.$refs.spinner.hideSpinner();
        this.dataLoaded = true;
      }
    },
    /**
     * This function shows last n elements from mini cart
     * @param  {Array} array products from mini cart response
     */
    lastNelements(array) {
      const filteredArray = array.filter(item => item.visible);
      return filteredArray.slice(Math.max(filteredArray.length - this.displayCount, 0));
    },
        /**
     * This function generates bundle data
     */
    generateBundleData() {
      this.bundles = [];
      const bundleProducts = this.shoppingCartData.entries.filter(product => product.hasOwnProperty('rootBundleTemplate'));
      const bundlesInCart = [];
      this.shoppingCartData.entries.forEach((product) => {
        if (product.hasOwnProperty('rootBundleTemplate') && (bundlesInCart.every(bundle =>
            (bundle.id !== product.rootBundleTemplate.id || bundle.number !== product.bundleNo)))) {
          bundlesInCart.push({
            id: product.rootBundleTemplate.id,
            number: product.bundleNo,
            name: product.rootBundleTemplate.name,
          });
        }
      });
      bundlesInCart.forEach((bundle, index) => {
        this.bundles.push({
          id: bundle.id,
          name: bundle.name,
          number: bundle.number,
          bundleTemplateList: [],
        });
        bundleProducts.forEach((product) => {
          if (product.rootBundleTemplate.id === bundle.id && product.bundleNo === bundle.number && !this.bundles[index].bundleTemplateList.some(
            leafBundle => leafBundle.id === product.component.id,
          )) {
            this.bundles[index].bundleTemplateList.push({
              id: product.component.id,
              name: product.component.name,
              maxItemsAllowed: product.component.maxItemsAllowed,
              minItemsAllowed: product.component.minItemsAllowed,
              products: [],
            });
          }
        });
      });
      bundlesInCart.forEach((bundle, index) => {
        bundleProducts.forEach((product) => {
          let leafIndex;
          this.bundles[index].bundleTemplateList.forEach((leaf, leafNo) => {
            if (leaf.id === product.component.id) {
              leafIndex = leafNo;
            }
          });
          if (product.rootBundleTemplate.id === bundle.id && product.bundleNo === bundle.number && this.bundles[index].bundleTemplateList[leafIndex].products.every(
            item => item.product.code !== product.product.code,
          )) {
            this.bundles[index].bundleTemplateList[leafIndex].products.push(product);
          }
        });
      });
      this.$forceUpdate();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/manage-shopping-cart/vx-mini-cart/vx-mini-cart.js